<template>
  <div v-if="areManyLanguages">
    <div v-if="modalOpen" class="language-backdrop" @click="onCloseLanguageSelector"/>
    <div class="language-selector-container">
      <div :style="myBlockProps.getStyles(visible)" class="clickable"
           @click="onOpenLanguageSelector">
        <img :src="selectedLanguageLocal.image"/>
        <span :style="textStyles">{{ selectedLanguageLocal.text }}</span>
      </div>
      <div v-show="modalOpen" class="language-selector" ref="modal">
        <div v-for="info in languageInfoOptions" :key="info.text"
             :style="myBlockProps.getStyles(visible)" class="clickable language-selector-item"
             @click.stop="onSelectLanguage(info.language)">
          <img :src="info.image"/>
          <span :style="textStyles">{{ info.text }}</span>
        </div>
      </div>
      <div class="deploy-icon">▼</div>
    </div>
  </div>
  <div v-else class="language-button-container">
    <div v-for="info in languageInfoList" :key="info.text" :style="myBlockProps.getStyles(visible)"
         class="clickable" @click="setSelectedLanguage(info.language)">
      <img :src="info.image"/>
      <span :style="textStyles">{{ info.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Block from './Block.vue';

import { LanguageInfo, TextProps } from '../models';

export default {
  name: 'language-block',
  extends: Block,
  data() {
    return {
      modalOpen: false
    };
  },
  props: {
    textProps: { type: Object, default: () => ({}) },
    languages: { type: Array, default: () => ([]) }
  },
  computed: {
    ...mapGetters(['selectedLanguage']),
    textStyles() {
      const textProperties = new TextProps(this.textProps);
      return textProperties.getStyles();
    },
    areManyLanguages() {
      return this.languageInfoList.length > 2;
    },
    languageInfoList() {
      return this.languages.map((languageInfo) => new LanguageInfo(languageInfo));
    },
    languageInfoOptions() {
      return this.languageInfoList.filter((info) => info.language !== this.selectedLanguage);
    },
    selectedLanguageLocal() {
      return this.languageInfoList.find((languageInfo) => languageInfo.language === this.selectedLanguage);
    }
  },
  methods: {
    ...mapActions(['setSelectedLanguage']),
    onOpenLanguageSelector() {
      this.modalOpen = true;
    },
    onSelectLanguage(language) {
      this.onCloseLanguageSelector();
      this.setSelectedLanguage(language);
    },
    onCloseLanguageSelector() {
      this.modalOpen = false;
    }
  },
  watch: {
    modalOpen(newOpen) {
      if (newOpen) {
        this.$refs.modal.focus();
      }
    }
  }
};
</script>

<style scoped lang="scss">
img {
  width: 35px;
  height: 25px;
}

.clickable {
  cursor: pointer;
}

.language-button-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  > :first-child {
    margin-right: 4px;
  }
}

.language-selector-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: relative;
}

.deploy-icon {
  padding-top: 4px;
  margin-right: 8px;
}

.language-selector {
  position: absolute;
  top: -1px;
  right: -1px;
  border-radius: 2px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  background-color: white;
  width: auto;
  min-width: 60px;
  padding-top: 12px;
  z-index: 1;
}

.language-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 0;
}

.language-selector-item {
  margin-bottom: 6px;
}

</style>
